import React from 'react';
import ArcText from '@src/core/ui/arc-text';
import ArcStack from '@src/core/ui/arc-stack';

import { ArcCellInfoProps } from './types';

const ArcCellInfo: React.FC<ArcCellInfoProps> = (props) => {
  const { label, children, labelProps, textProps, ...rest } = props;
  return (
    <ArcStack {...rest}>
      <ArcText.caption {...labelProps}>
        {label}
      </ArcText.caption>

      <ArcText.h6 fontWeight={500} {...textProps}>
        {children}
      </ArcText.h6>
    </ArcStack>
  );
};

export default ArcCellInfo;